module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_fukui-9b23106da72a9431fbcb51188a5dbbef.png";